<div id="trustpilotterms">
    <div class="full-width-image-section trustpilot-terms-top">
        <div class="arrow-up">
            <next-topbar></next-topbar>
            <next-menu></next-menu>

            <div class="container white">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <h1>{{ 'PAGE.TRUSTPILOT_TERMS.TITLE' | translate }}</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container container-padding-40-40">
        <div class="row">
            <div class="col-sm-12" [innerHTML]="contex?.content | safehtml"></div>
        </div>
    </div>

    <next-footer></next-footer>
</div>
